import {
  AssetInput,
  PageType,
  ThemeSettingsFragment,
  MediaRefFragment,
  PresenterFragment,
  PublicEWebinarFragment,
  PublicSetFragment,
  FullSeriesFragment,
  PublicSeriesFragment,
} from '$/GraphQL/schema/types';
import { CTAConfig } from './CTAButton/types';

export enum PageMode {
  preview = 'preview',
  edit = 'edit',
  public = 'public',
}

export enum PageName {
  registrationPage = 'registrationPage',
  registrationForm = 'registrationForm',
  thankyouPage = 'thankyouPage',
  regSettings = 'regSettings',
  presentation = 'presentation',
}

export const pageNameToPageType = (pageName: PageName | undefined): PageType => {
  switch (pageName) {
    case PageName.registrationPage:
      return PageType.Registration;
    case PageName.thankyouPage:
      return PageType.Thankyou;
    default:
      return PageType.Registration;
  }
};

export interface PageBuilderState {
  page: PageName;
  mode: PageMode;
  setMode?: (mode: PageMode) => void;

  isRtl?: boolean;
  isPublic?: boolean;
  hideBranding?: boolean;
  hasPreRendered?: boolean;

  language: string;
  themeSettings: ThemeSettingsFragment;

  teamId?: string;
  ewebinarId?: string;
  seriesId?: string;

  logoMediaRef?: MediaRefFragment;
  presenters?: PresenterFragment[];

  ewebinar?: PublicEWebinarFragment;
  set?: PublicSetFragment;
  series?: FullSeriesFragment | PublicSeriesFragment;

  ctaConfig?: CTAConfig;
}

export type PBState = Omit<
  PageBuilderState,
  'ewebinar' | 'set' | 'themeSettings' | 'series' | 'page' | 'language'
>;

export interface LocalAsset extends AssetInput {
  fit?: 'cover' | 'contain';
  position?: 'top center' | 'center center' | 'bottom center';
  hideRecommended?: boolean;
}
